import StatsModal from './StatsModal';
import ModalCreateClink from '../clinks/ModalCreateClink';
import ModalEditClink from '../clinks/ModalEditClink';
import ModalTrackingLinks from '../clinks/ModalTrackingLinks';
import ModalHistory from '../clinks/ModalHistory';
import { LookupApp } from './types';

interface LookupModalsProps {
  // Stats Modal
  showStatsModal: boolean;
  setShowStatsModal: (show: boolean) => void;
  selectedApp: LookupApp | null;
  currentUser: any;

  // Create cLink Modal
  showCreateClinkModal: boolean;
  selectedAppForClink: LookupApp | null;
  selectedCampaignId: string | null;
  selectedDemandSourceId: string | null;
  onCloseCreateClink: () => void;

  // Edit cLink Modal
  showEditClinkModal: boolean;
  setShowEditClinkModal: (show: boolean) => void;
  selectedClink: any;
  onReloadClink: () => void;

  // Tracking Links Modal
  showTrackingLinksModal: boolean;
  setShowTrackingLinksModal: (show: boolean) => void;

  // History Modal
  showHistoryModal: boolean;
  setShowHistoryModal: (show: boolean) => void;
}

const LookupModals = ({
  // Stats Modal props
  showStatsModal,
  setShowStatsModal,
  selectedApp,
  currentUser,

  // Create cLink Modal props
  showCreateClinkModal,
  selectedAppForClink,
  selectedCampaignId,
  selectedDemandSourceId,
  onCloseCreateClink,

  // Edit cLink Modal props
  showEditClinkModal,
  setShowEditClinkModal,
  selectedClink,
  onReloadClink,

  // Tracking Links Modal props
  showTrackingLinksModal,
  setShowTrackingLinksModal,

  // History Modal props
  showHistoryModal,
  setShowHistoryModal
}: LookupModalsProps) => {
  return (
    <>
      {/* Stats Modal */}
      {selectedApp && (
        <StatsModal
          show={showStatsModal}
          onHide={() => setShowStatsModal(false)}
          app={selectedApp}
          currentUser={currentUser}
          selectedCampaign={selectedClink}
        />
      )}

      {/* Create cLink Modal */}
      {selectedAppForClink && showCreateClinkModal && (
        <ModalCreateClink
          app={selectedAppForClink}
          campaignId={selectedCampaignId || undefined}
          demandSourceId={selectedDemandSourceId || undefined}
          closeCreateClink={onCloseCreateClink}
          currentUser={currentUser}
        />
      )}

      {/* Edit cLink Modal */}
      {showEditClinkModal && selectedClink && selectedApp && (
        <ModalEditClink 
          app={selectedApp}
          clinkId={selectedClink.clink_id}
          closeEditClink={() => setShowEditClinkModal(false)}
          reloadClink={onReloadClink}
        />
      )}

      {/* Tracking Links Modal */}
      {showTrackingLinksModal && selectedClink && selectedApp && (
        <ModalTrackingLinks 
          showTrackingLinks={showTrackingLinksModal}
          setShowTrackingLinks={setShowTrackingLinksModal}
          clinkid={selectedClink.clink_id}
          previewLink={selectedClink.previewLink}
          app={selectedApp}
        />
      )}

      {/* History Modal */}
      {showHistoryModal && selectedClink && selectedApp && (
        <ModalHistory 
          showHistory={showHistoryModal}
          setShowHistory={setShowHistoryModal}
          clink={selectedClink}
          app={selectedApp}
        />
      )}
    </>
  );
};

export default LookupModals;